<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path d="M20 39.6c-5.3 0-10.2-2-13.9-5.7S.4 25.3.4 20s2-10.2 5.7-13.9S14.7.4 20 .4c4.4 0 8.7 1.5 12.1 4.2.6.5 1.2 1 1.7 1.5l.3.3V5.3c0-.7.5-1.3 1.2-1.4h.2c.7 0 1.3.5 1.4 1.2v5.4c0 .7-.5 1.3-1.2 1.4h-5.4c-.8 0-1.4-.6-1.4-1.4 0-.7.5-1.3 1.2-1.4h2.5l-.3-.3c-.7-.7-1.4-1.3-2-1.9-2.9-2.4-6.5-3.6-10.3-3.6-9.2 0-16.7 7.5-16.7 16.7S10.8 36.7 20 36.7 36.7 29.2 36.7 20c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4c0 5.3-2 10.2-5.7 13.9-3.6 3.7-8.5 5.7-13.8 5.7zm0-10.4c-1.4 0-2.8-.5-3.7-1.5l-3.9-3.9c-1.1-1.1-1.6-2.4-1.6-3.9 0-1.4.5-2.8 1.5-3.7l4-4c1-1 2.4-1.6 3.8-1.6s2.8.5 3.7 1.5l3.9 3.9c1.1 1.1 1.6 2.4 1.6 3.9 0 1.4-.5 2.8-1.5 3.7l-3.9 3.9c-1.1 1.1-2.5 1.7-3.9 1.7zm-.1-15.5c-.5 0-.9.2-1.3.5l-4.4 4.4c-.7.7-.8 1.9-.1 2.7l4.5 4.5c.3.5.7.7 1.3.7.5 0 1-.3 1.3-.5l4.4-4.4c.4-.4.6-.9.6-1.5 0-.5-.2-.9-.4-1.2v-.1l-.1-.1-4.4-4.4c-.3-.4-.8-.6-1.4-.6z" data-follow-fill="currentColor" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
